import React, { useState } from 'react'
import DetailList from './DetailList'
import { makeOptions, valueEquals } from './utils'
import PropTypes from 'prop-types'
import {
  SelectDetailBox,
  SelectBox,
  StyledSelectContainer,
  Button,
  SelectStyles
} from './styled'
import Select from 'react-select'
import { find } from 'ramda'

const SelectDetailDefinition = ({
  items,
  selected = [],
  addHandler,
  removeHandler,
  selectionHeader,
  defaultText,
  noResultsText
}) => {
  const [currentSelection, setCurrentSelection] = useState('')
  const onAddHandler = () => {
    setCurrentSelection('')
    const [val] = items.filter(item => item.label === currentSelection)
    addHandler(val)
  }
  const onSelectChange = ({ value }) => setCurrentSelection(value)
  const options = [{ value: '', label: defaultText }, ...makeOptions(items, selected)]
  const value = find(valueEquals(currentSelection))(options)

  return (
    <SelectDetailBox>
      <SelectBox>
        <StyledSelectContainer>
          <Select role='listbox' value={value} options={options} onChange={onSelectChange} styles={SelectStyles} />
        </StyledSelectContainer>
        <Button disabled={!currentSelection} onClick={onAddHandler}>ADD</Button>
      </SelectBox>
      <DetailList
        label={selectionHeader}
        items={selected}
        removeHandler={removeHandler}
        noResultsText={noResultsText}
      />
    </SelectDetailBox>
  )
}

SelectDetailDefinition.displayName = 'SelectDetailList'
SelectDetailDefinition.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string
  })).isRequired,
  selected: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string
  })),
  addHandler: PropTypes.func,
  removeHandler: PropTypes.func,
  sortHandler: PropTypes.func,
  selectionHeader: PropTypes.string,
  placeholder: PropTypes.string,
  noResultsText: PropTypes.string
}

export default SelectDetailDefinition
